import script from "./view.vue?vue&type=script&setup=true&lang=js"
export * from "./view.vue?vue&type=script&setup=true&lang=js"

import "./view.vue?vue&type=style&index=0&id=70841ed6&scoped=true&lang=css"
import "./view.vue?vue&type=style&index=1&id=70841ed6&lang=css"

import exportComponent from "/home/staging-tcms.qpax-tcms.net/public_html/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-70841ed6"]])

export default __exports__